<div class="app-wrapper relative" [dir]="(isHebrew$ | async) ? 'rtl' : 'ltr'">
  <div
    *ngIf="(isLoading$ | async) && !(isHebrew$ | async)"
    class="app-lottie-wrapper"
  >
    <ng-lottie
      [options]="lottieOptions"
      width="250px"
      height="250px"
      [styles]="lottieStyles"
    ></ng-lottie>
  </div>
  <div
    *ngIf="(isLoading$ | async) && (isHebrew$ | async)"
    class="app-lottie-wrapper"
  >
    <ng-lottie
      [options]="lottieOptions"
      width="250px"
      height="250px"
      [styles]="lottieStylesHeb"
    ></ng-lottie>
  </div>
  <router-outlet></router-outlet>
</div>
